/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CursorPaginatedResponseUserQueryDto } from '../models/cursor-paginated-response-user-query-dto';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { PaginatedResponseUserQueryDto } from '../models/paginated-response-user-query-dto';
import { PaginationWithFiltersRequest } from '../models/pagination-with-filters-request';
import { UserCommand } from '../models/user-command';
import { UserInviteColleagueCommand } from '../models/user-invite-colleague-command';
import { UserProfileUpdateDto } from '../models/user-profile-update-dto';
import { UserQueryDto } from '../models/user-query-dto';
import { UserUpdateCommand } from '../models/user-update-command';


/**
 * API for browse and manage users.
 */
@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createUser
   */
  static readonly CreateUserPath = '/users';

  /**
   * Create new user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params: {

    /**
     * User to be created
     */
    body: UserCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.CreateUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Create new user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params: {

    /**
     * User to be created
     */
    body: UserCommand
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.createUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation resendInvitation
   */
  static readonly ResendInvitationPath = '/users/{id}/resend-invitation';

  /**
   * Resend user invitation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resendInvitation()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendInvitation$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ResendInvitationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Resend user invitation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resendInvitation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resendInvitation(params: {
    id: string;
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.resendInvitation$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation deactivateUser
   */
  static readonly DeactivateUserPath = '/users/{email}/deactivate';

  /**
   * Deactivate a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateUser$Response(params: {
    email: string;
    reason?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.DeactivateUserPath, 'post');
    if (params) {
      rb.path('email', params.email, {});
      rb.query('reason', params.reason, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Deactivate a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deactivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateUser(params: {
    email: string;
    reason?: string;
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.deactivateUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation reactivateUser
   */
  static readonly ReactivateUserPath = '/users/{email}/activate';

  /**
   * Reactivate a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reactivateUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateUser$Response(params: {
    email: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ReactivateUserPath, 'post');
    if (params) {
      rb.path('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Reactivate a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reactivateUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reactivateUser(params: {
    email: string;
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.reactivateUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation listUsers
   */
  static readonly ListUsersPath = '/users/list';

  /**
   * List available users.
   *
   * Deprecated: use /cursor-list instead. Provides list of users. Users are returned as unordered list.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listUsers$Response(params: {

    /**
     * Pagination, sorting, and filter parameters for users
     */
    body: PaginationWithFiltersRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaginatedResponseUserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ListUsersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaginatedResponseUserQueryDto>;
      })
    );
  }

  /**
   * List available users.
   *
   * Deprecated: use /cursor-list instead. Provides list of users. Users are returned as unordered list.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listUsers(params: {

    /**
     * Pagination, sorting, and filter parameters for users
     */
    body: PaginationWithFiltersRequest
  },
  context?: HttpContext

): Observable<PaginatedResponseUserQueryDto> {

    return this.listUsers$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaginatedResponseUserQueryDto>) => r.body as PaginatedResponseUserQueryDto)
    );
  }

  /**
   * Path part for operation inviteColleague
   */
  static readonly InviteColleaguePath = '/users/invite-colleague';

  /**
   * Invite colleague to supplier portal.
   *
   * Allows supplier users to invite colleagues to their supplier organization. The supplier ID is automatically populated from the authenticated user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteColleague()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteColleague$Response(params: {

    /**
     * Colleague details to invite
     */
    body: UserInviteColleagueCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.InviteColleaguePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Invite colleague to supplier portal.
   *
   * Allows supplier users to invite colleagues to their supplier organization. The supplier ID is automatically populated from the authenticated user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteColleague$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteColleague(params: {

    /**
     * Colleague details to invite
     */
    body: UserInviteColleagueCommand
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.inviteColleague$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation listUsersCursor
   */
  static readonly ListUsersCursorPath = '/users/cursor-list';

  /**
   * List users using cursor-based pagination.
   *
   * Retrieves users using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUsersCursor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listUsersCursor$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseUserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.ListUsersCursorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseUserQueryDto>;
      })
    );
  }

  /**
   * List users using cursor-based pagination.
   *
   * Retrieves users using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUsersCursor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listUsersCursor(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseUserQueryDto> {

    return this.listUsersCursor$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseUserQueryDto>) => r.body as CursorPaginatedResponseUserQueryDto)
    );
  }

  /**
   * Path part for operation adminUpdateUser
   */
  static readonly AdminUpdateUserPath = '/users/{userId}';

  /**
   * Update a user's profile (admin only).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminUpdateUser$Response(params: {
    userId: string;
    body: UserUpdateCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.AdminUpdateUserPath, 'patch');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Update a user's profile (admin only).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminUpdateUser(params: {
    userId: string;
    body: UserUpdateCommand
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.adminUpdateUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation getOwnUser
   */
  static readonly GetOwnUserPath = '/users/me';

  /**
   * Get own user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOwnUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOwnUser$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.GetOwnUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Get own user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOwnUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOwnUser(params?: {
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.getOwnUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation updateOwnUser
   */
  static readonly UpdateOwnUserPath = '/users/me';

  /**
   * Update current user's first and last name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOwnUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOwnUser$Response(params: {
    body: UserProfileUpdateDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UpdateOwnUserPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserQueryDto>;
      })
    );
  }

  /**
   * Update current user's first and last name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOwnUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOwnUser(params: {
    body: UserProfileUpdateDto
  },
  context?: HttpContext

): Observable<UserQueryDto> {

    return this.updateOwnUser$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserQueryDto>) => r.body as UserQueryDto)
    );
  }

  /**
   * Path part for operation searchApproverUsersV1
   */
  static readonly SearchApproverUsersV1Path = '/users/approvers';

  /**
   * List available approver users.
   *
   * Returns active ADMIN and STANDARD users whose first name, last name, or email contains the search term. Results are sorted by first name ascending. Use the continuationToken from the response to retrieve the next page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchApproverUsersV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchApproverUsersV1$Response(params?: {
    search?: string;
    size?: number;
    continuationToken?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseUserQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.SearchApproverUsersV1Path, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('size', params.size, {});
      rb.query('continuationToken', params.continuationToken, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseUserQueryDto>;
      })
    );
  }

  /**
   * List available approver users.
   *
   * Returns active ADMIN and STANDARD users whose first name, last name, or email contains the search term. Results are sorted by first name ascending. Use the continuationToken from the response to retrieve the next page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchApproverUsersV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchApproverUsersV1(params?: {
    search?: string;
    size?: number;
    continuationToken?: string;
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseUserQueryDto> {

    return this.searchApproverUsersV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseUserQueryDto>) => r.body as CursorPaginatedResponseUserQueryDto)
    );
  }

}
